import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'itemNewPratica'
})
export class ItemNewPraticaPipe implements PipeTransform {
  transform(namePratica: any): any {
    let titlePratica;
    if (namePratica.toLowerCase() === 'pareristico') {
      titlePratica = 'Consulenza e disciplina';
    } else if (namePratica.toLowerCase() === 'autorita\' indipendente e regolatoria') {
      titlePratica = 'Autorità indipendente';
    } else {
      titlePratica = namePratica;
    }
    return titlePratica;
  }
}
